// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProposalTsb_membersProfileTabs__W8Cgt .ProposalTsb_profileDetailsWrp__59CWB {
  margin-top: 16px;
}
.ProposalTsb_membersProfileTabs__W8Cgt .ProposalTsb_timeLineTopRow__nBd0E {
  width: 100%;
  padding-bottom: 12px;
}
.ProposalTsb_membersProfileTabs__W8Cgt .ProposalTsb_timeLineTopRow__nBd0E .ProposalTsb_filterBtns__4QA-d {
  display: flex;
  gap: 12px;
  align-items: center;
  flex: 1 1;
  justify-content: flex-end;
}
.ProposalTsb_membersProfileTabs__W8Cgt .ProposalTsb_timeLineTopRow__nBd0E .ProposalTsb_filterBtns__4QA-d .ProposalTsb_rightActions__s8jWm {
  display: flex;
  align-items: center;
  gap: 12px;
}
.ProposalTsb_membersProfileTabs__W8Cgt .ProposalTsb_timeLineTopRow__nBd0E .ProposalTsb_filterBtns__4QA-d .ProposalTsb_left__cvdGp .ProposalTsb_tabItem__yCUU7 {
  display: flex;
  align-items: center;
  gap: 8px;
  text-align: left;
}
.ProposalTsb_membersProfileTabs__W8Cgt .ProposalTsb_timeLineTopRow__nBd0E .ProposalTsb_filterBtns__4QA-d .ProposalTsb_left__cvdGp .ProposalTsb_tabItem__yCUU7.ProposalTsb_selected__t3UCt img,
.ProposalTsb_membersProfileTabs__W8Cgt .ProposalTsb_timeLineTopRow__nBd0E .ProposalTsb_filterBtns__4QA-d .ProposalTsb_left__cvdGp .ProposalTsb_tabItem__yCUU7.ProposalTsb_selected__t3UCt svg {
  filter: grayscale(0);
}
.ProposalTsb_membersProfileTabs__W8Cgt .ProposalTsb_timeLineTopRow__nBd0E .ProposalTsb_filterBtns__4QA-d .ProposalTsb_left__cvdGp .ProposalTsb_tabItem__yCUU7.ProposalTsb_selected__t3UCt span {
  color: var(--brand);
}
.ProposalTsb_membersProfileTabs__W8Cgt .ProposalTsb_timeLineTopRow__nBd0E .ProposalTsb_filterBtns__4QA-d .ProposalTsb_left__cvdGp .ProposalTsb_tabItem__yCUU7 span {
  color: var(--secondary-Text);
  font: var(--body-font-three);
  font-weight: 500;
}
.ProposalTsb_membersProfileTabs__W8Cgt .ProposalTsb_timeLineTopRow__nBd0E .ProposalTsb_filterBtns__4QA-d .ProposalTsb_left__cvdGp .ProposalTsb_tabItem__yCUU7 img,
.ProposalTsb_membersProfileTabs__W8Cgt .ProposalTsb_timeLineTopRow__nBd0E .ProposalTsb_filterBtns__4QA-d .ProposalTsb_left__cvdGp .ProposalTsb_tabItem__yCUU7 svg {
  width: 16px;
  height: 16px;
  display: block;
  filter: grayscale(1);
}

@media (max-width: 599px) {
  .ProposalTsb_membersProfileTabs__W8Cgt .ProposalTsb_timeLineTopRow__nBd0E .ProposalTsb_filterBtns__4QA-d .ProposalTsb_rightActions__s8jWm {
    width: 100%;
  }
  .ProposalTsb_membersProfileTabs__W8Cgt .ProposalTsb_timeLineTopRow__nBd0E .ProposalTsb_filterBtns__4QA-d .ProposalTsb_rightActions__s8jWm button {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Proposal/ProposalTsb.module.scss"],"names":[],"mappings":"AACC;EACC,gBAAA;AAAF;AAGC;EACC,WAAA;EACA,oBAAA;AADF;AAGE;EACC,aAAA;EAEA,SAAA;EACA,mBAAA;EACA,SAAA;EACA,yBAAA;AAFH;AAIG;EACC,aAAA;EACA,mBAAA;EACA,SAAA;AAFJ;AAMI;EACC,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;AAJL;AAOM;;EAEC,oBAAA;AALP;AAQM;EACC,mBAAA;AANP;AAUK;EACC,4BAAA;EACA,4BAAA;EACA,gBAAA;AARN;AAWK;;EAEC,WAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;AATN;;AAiBA;EAOI;IACC,WAAA;EApBH;EAsBG;IACC,WAAA;EApBJ;AACF","sourcesContent":[".membersProfileTabs {\r\n\t.profileDetailsWrp {\r\n\t\tmargin-top: 16px;\r\n\t}\r\n\r\n\t.timeLineTopRow {\r\n\t\twidth: 100%;\r\n\t\tpadding-bottom: 12px;\r\n\r\n\t\t.filterBtns {\r\n\t\t\tdisplay: flex;\r\n\t\t\t// flex-wrap: wrap;\r\n\t\t\tgap: 12px;\r\n\t\t\talign-items: center;\r\n\t\t\tflex: 1;\r\n\t\t\tjustify-content: flex-end;\r\n\r\n\t\t\t.rightActions {\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\talign-items: center;\r\n\t\t\t\tgap: 12px;\r\n\t\t\t}\r\n\r\n\t\t\t.left {\r\n\t\t\t\t.tabItem {\r\n\t\t\t\t\tdisplay: flex;\r\n\t\t\t\t\talign-items: center;\r\n\t\t\t\t\tgap: 8px;\r\n\t\t\t\t\ttext-align: left;\r\n\r\n\t\t\t\t\t&.selected {\r\n\t\t\t\t\t\timg,\r\n\t\t\t\t\t\tsvg {\r\n\t\t\t\t\t\t\tfilter: grayscale(0);\r\n\t\t\t\t\t\t}\r\n\r\n\t\t\t\t\t\tspan {\r\n\t\t\t\t\t\t\tcolor: var(--brand);\r\n\t\t\t\t\t\t}\r\n\t\t\t\t\t}\r\n\r\n\t\t\t\t\tspan {\r\n\t\t\t\t\t\tcolor: var(--secondary-Text);\r\n\t\t\t\t\t\tfont: var(--body-font-three);\r\n\t\t\t\t\t\tfont-weight: 500;\r\n\t\t\t\t\t}\r\n\r\n\t\t\t\t\timg,\r\n\t\t\t\t\tsvg {\r\n\t\t\t\t\t\twidth: 16px;\r\n\t\t\t\t\t\theight: 16px;\r\n\t\t\t\t\t\tdisplay: block;\r\n\t\t\t\t\t\tfilter: grayscale(1);\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@media (max-width: 599px) {\r\n\t.membersProfileTabs {\r\n\t\t.timeLineTopRow {\r\n\t\t\t.filterBtns {\r\n\t\t\t\t// flex-direction: column;\r\n\t\t\t\t// align-items: flex-start;\r\n\r\n\t\t\t\t.rightActions {\r\n\t\t\t\t\twidth: 100%;\r\n\r\n\t\t\t\t\tbutton {\r\n\t\t\t\t\t\twidth: 100%;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"membersProfileTabs": `ProposalTsb_membersProfileTabs__W8Cgt`,
	"profileDetailsWrp": `ProposalTsb_profileDetailsWrp__59CWB`,
	"timeLineTopRow": `ProposalTsb_timeLineTopRow__nBd0E`,
	"filterBtns": `ProposalTsb_filterBtns__4QA-d`,
	"rightActions": `ProposalTsb_rightActions__s8jWm`,
	"left": `ProposalTsb_left__cvdGp`,
	"tabItem": `ProposalTsb_tabItem__yCUU7`,
	"selected": `ProposalTsb_selected__t3UCt`
};
export default ___CSS_LOADER_EXPORT___;
